export const DATATYPES = [
  { id: 1, name: "String" },
  { id: 2, name: "Boolean" }
];

export default {
  computed: {
    datatypes: function () {
      return DATATYPES;
    }
  },
  methods: {
    isString(datatype_id) {
      return datatype_id == 1;
    },
    isBoolean(datatype_id) {
      return datatype_id == 2;
    }
  }
};
